<template>
  <div class="faq">
    <h2 class="faq__title">Domande frequenti</h2>

    <div class="faq__list" role="tablist">
      <div
        v-for="(item, index) in faqs"
        :key="index"
        class="faq__item"
      >
        <button
          v-b-toggle="_uid + '_faq_' + index"
          type="button"
          class="faq__question"
        >
          <span>{{ item.question }}</span>

          <vb-icon
            class="faq__chevron"
            name="angle_small_down"
            :color="sass('gray-900')"
            :size="26"
          />
        </button>

        <!-- accordion: una sola voce aperta alla volta -->
        <b-collapse
          :id="_uid + '_faq_' + index"
          accordion="faq"
          role="tabpanel"
        >
          <p class="faq__answer">{{ item.answer }}</p>
        </b-collapse>
      </div>
    </div>
  </div>
</template>

<script>
  import { VALIDITY_MONTHS } from '@livegift/resources';

  export default {
    name: 'faq',

    data() {
      return {
        // copy da confermare
        faqs: [
          {
            question: 'Posso usare la Gift Card per più prenotazioni?',
            answer: `Sì. La Gift Card è associata a un credito a scalare. Se l'importo speso è inferiore al valore della card, potrai utilizzare il saldo rimanente per prenotazioni successive.`,
          },
          {
            question: `Cosa succede se non uso tutto l'importo?`,
            answer: `L'importo non utilizzato rimane come saldo disponibile sulla tua Gift Card sotto forma di credito residuo. Potrai spenderlo per altri viaggi entro la data di scadenza della card, ovvero ${VALIDITY_MONTHS} mesi dal momento del suo acquisto iniziale. Ricorda che il credito residuo non è mai monetizzabile o convertibile in denaro.`,
          },
          {
            question: 'Posso integrare la Gift Card con altri metodi di pagamento?',
            answer: `Sì. È prevista l'integrazione con la tua carta di credito in fase di utilizzo. Se il costo del viaggio che stai prenotando supera il valore o il saldo residuo della tua Gift Card, potrai pagare la differenza comodamente con la tua carta di credito.`,
          },
          {
            question: 'Entro quanto ricevo la Gift Card?',
            answer: `La consegna è immediata. Subito dopo aver confermato l'acquisto tramite il tuo credito welfare, il sistema genera la card e invia un'email di conferma con il codice e le istruzioni per usarla.`,
          },
          {
            question: 'Come si utilizza la Gift Card?',
            answer: `
                Dopo l’acquisto, ricevi subito le istruzioni per utilizzare la tua Gift Card. Dovrai semplicemente cliccare sul link che trovi nella mail e accedere al servizio scelto. Troverai il credito della Gift Card già caricato.
                Se il valore della prenotazione è uguale al valore della Gift Card, potrai confermare la prenotazione senza ricorrere alla tua carta di credito, né a procedure complesse: basterà un clic.
                Se il valore della prenotazione è inferiore a quello della Gift Card, potrai usufruire dell’importo residuo in un secondo momento.
                Se il valore della prenotazione è superiore al valore della Gif Card, dovrai semplicemente pagare la differenza con la tua carta di credito.
            `,
          },
        ],
      };
    },
  };
</script>

<style lang="scss" scoped>

  .faq {
    margin-top: $grid-gutter-width;

    &__title {
      margin: 0 0 $grid-gutter-20;
      font-size: $font-size-xl;
      color: $gray-700;
    }

    &__list > * + * {
      margin-top: $grid-gutter-20 / 2;
    }

    &__item {
      background-color: $white;
      border-radius: $border-radius-lg * 2;
    }

    // il bottone occupa tutta la riga: la voce è cliccabile per intero
    &__question {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      padding: ($grid-gutter-width / 2) $grid-gutter-20;
      font-size: $font-size-base;
      color: $gray-900;
      text-align: left;
      background-color: transparent;
      border: 0;

      // la classe la mette v-b-toggle sul bottone quando il collapse è aperto
      &.not-collapsed .faq__chevron {
        transform: rotate(180deg);
      }
    }

    &__chevron {
      flex-shrink: 0;
      margin-left: $grid-gutter-width / 2;
      transition: transform .2s ease;
    }

    &__answer {
      padding: 0 $grid-gutter-20 ($grid-gutter-width / 2);
      margin: 0;
      font-size: $font-size-md;
      color: $gray-700;
    }
  }
</style>